// @flow

import Auth0 from './Auth0';
import reducer from './reducer';
import middleware from './middleware';
import types from './types';

import AuthLayout from './components/layout';

import type {Auth0Conf} from './TypeDefinitions';

let auth0;

export {
    auth0,
    AuthLayout,
    types,
};

export default (config: Auth0Conf) => {
    auth0 = new Auth0(config);

    return ({
        reducer,
        middleware: middleware(auth0),
    });
}
